// Fases fenológicas médias por cultura
// Fontes: Embrapa Soja (2023), Embrapa Milho e Sorgo (2022), Embrapa Arroz e Feijão (2022),
//         Embrapa Algodão (2021), IAC/Embrapa Café (2022), RPA/Embrapa Cana (2023),
//         Embrapa Trigo (2022), Embrapa Florestas - Eucalipto (2021), FAO-56 (1998),
//         CEPLAC e Embrapa Gado de Corte.
// Os períodos são referências médias e podem ser ajustados no talhão conforme cultivar, clima e manejo.
export const fenologiaCultural = {
  soja: [
    // Embrapa Soja: ciclo médio ~117 dias (precoce ~105, tardio ~130)
    { fase: 'Germinação', dias: 7 },
    { fase: 'Crescimento vegetativo', dias: 40 },   // V1–V6: ~40 dias
    { fase: 'Florescimento', dias: 15 },             // R1–R2
    { fase: 'Frutificação', dias: 35 },              // R3–R5: formação e enchimento de grãos
    { fase: 'Maturação', dias: 20 }                  // R6–R8
  ],
  milho: [
    // Embrapa Milho e Sorgo: ciclo médio ~125 dias (precoce ~110, normal ~130)
    { fase: 'Germinação', dias: 6 },
    { fase: 'Crescimento vegetativo', dias: 45 },   // V1–V12
    { fase: 'Florescimento', dias: 12 },             // VT–R1: pendoamento e espigamento
    { fase: 'Frutificação', dias: 40 },              // R2–R4: grão leitoso a pastoso
    { fase: 'Maturação', dias: 22 }                  // R5–R6
  ],
  cafe: [
    { fase: 'Repouso vegetativo', dias: 60 },
    { fase: 'Brotação e florescimento', dias: 45 },
    { fase: 'Chumbinho', dias: 30 },
    { fase: 'Expansão do fruto', dias: 90 },
    { fase: 'Granação', dias: 60 },
    { fase: 'Maturação', dias: 80 }
  ],
  cafe_conilon: [
    { fase: 'Repouso vegetativo', dias: 30 },
    { fase: 'Brotação e florescimento', dias: 60 },
    { fase: 'Chumbinho', dias: 30 },
    { fase: 'Expansão do fruto', dias: 90 },
    { fase: 'Granação', dias: 75 },
    { fase: 'Maturação', dias: 90 }
  ],
  trigo: [
    // Embrapa Trigo: ciclo médio ~100-115 dias
    { fase: 'Germinação', dias: 8 },
    { fase: 'Afilhamento', dias: 25 },               // fase característica do trigo
    { fase: 'Elongação/Espigamento', dias: 20 },
    { fase: 'Florescimento', dias: 10 },
    { fase: 'Frutificação', dias: 25 },
    { fase: 'Maturação', dias: 15 }
  ],
  cana_de_acucar: [
    // Embrapa/RPA: ciclo cana-planta ~330-365 dias
    { fase: 'Brotação', dias: 20 },
    { fase: 'Perfilhamento', dias: 60 },              // fase ausente na versão anterior
    { fase: 'Crescimento vegetativo', dias: 210 },   // elongação dos colmos
    { fase: 'Maturação', dias: 60 }
  ],
  feijao: [
    // Embrapa Arroz e Feijão: ciclo médio ~80-90 dias
    { fase: 'Germinação', dias: 7 },
    { fase: 'Crescimento vegetativo', dias: 25 },
    { fase: 'Florescimento', dias: 10 },
    { fase: 'Frutificação', dias: 20 },
    { fase: 'Maturação', dias: 15 }
  ],
  arroz: [
    // Embrapa Arroz: ciclo médio ~120 dias (irrigado), ~130 dias (sequeiro)
    { fase: 'Germinação', dias: 7 },
    { fase: 'Crescimento vegetativo', dias: 50 },    // perfilhamento ativo
    { fase: 'Elongação/Primórdio floral', dias: 20 },
    { fase: 'Florescimento', dias: 10 },
    { fase: 'Frutificação', dias: 35 },
    { fase: 'Maturação', dias: 18 }
  ],
  algodao: [
    // Embrapa Algodão: ciclo médio ~150-170 dias
    { fase: 'Germinação', dias: 7 },
    { fase: 'Crescimento vegetativo', dias: 40 },
    { fase: 'Florescimento/Botão floral', dias: 20 },
    { fase: 'Frutificação (maçãs)', dias: 50 },      // formação e desenvolvimento das maçãs
    { fase: 'Maturação (capulhos)', dias: 30 }        // abertura e colheita
  ],
  eucalipto: [
    { fase: 'Plantio e pegamento', dias: 30 },
    { fase: 'Crescimento inicial', dias: 335 },
    { fase: 'Crescimento acelerado', dias: 730 },
    { fase: 'Crescimento pleno', dias: 730 },
    { fase: 'Maturação/Colheita', dias: 730 }
  ],
  girassol: [
    // Embrapa Soja (Girassol): ciclo médio ~110-120 dias
    { fase: 'Germinação', dias: 7 },
    { fase: 'Crescimento vegetativo', dias: 28 },    // V1–V8: roseta e elongação
    { fase: 'Botão floral', dias: 15 },              // R1–R3
    { fase: 'Florescimento', dias: 10 },             // R4–R5: antese
    { fase: 'Enchimento de grãos', dias: 30 },       // R6–R7
    { fase: 'Maturação', dias: 22 }                  // R8–R9
  ],
  sorgo: [
    // Embrapa Milho e Sorgo: ciclo médio ~100-115 dias
    { fase: 'Germinação', dias: 6 },
    { fase: 'Crescimento vegetativo', dias: 38 },    // V1–V10
    { fase: 'Pendoamento/Florescimento', dias: 15 }, // boot a antese
    { fase: 'Enchimento de grãos', dias: 28 },       // grão leitoso a pastoso
    { fase: 'Maturação', dias: 20 }                  // maturidade fisiológica
  ],
  amendoim: [
    // Embrapa Amendoim: ciclo médio ~120-130 dias
    { fase: 'Germinação', dias: 9 },
    { fase: 'Crescimento vegetativo', dias: 28 },    // V1–V5
    { fase: 'Florescimento', dias: 18 },             // R1–R2: início a pleno florescimento
    { fase: 'Formação de vagens', dias: 32 },        // R3–R5: cravo a vagem cheia
    { fase: 'Maturação', dias: 28 }                  // R6–R8
  ],
  mandioca: [
    // Embrapa Mandioca: ciclo de 12 meses (variedades precoces)
    { fase: 'Brotação e enraizamento', dias: 45 },   // estabelecimento das manivas
    { fase: 'Crescimento vegetativo inicial', dias: 90 }, // parte aérea e início de tuberização
    { fase: 'Tuberização intensa', dias: 120 },      // engrossamento das raízes
    { fase: 'Maturação/Acúmulo de amido', dias: 110 } // colheita típica 12 meses
  ],
  tomate: [
    // FAO-56, Tabela 11: ciclo representativo de 145 dias.
    { fase: 'Estabelecimento e crescimento inicial', dias: 30 },
    { fase: 'Desenvolvimento vegetativo', dias: 40 },
    { fase: 'Florescimento e formação de frutos', dias: 45 },
    { fase: 'Maturação e colheita', dias: 30 }
  ],
  batata: [
    // FAO-56, Tabela 11: ciclo representativo de 130 dias.
    { fase: 'Brotação e emergência', dias: 25 },
    { fase: 'Crescimento vegetativo e estolonização', dias: 30 },
    { fase: 'Iniciação e enchimento de tubérculos', dias: 45 },
    { fase: 'Maturação e senescência', dias: 30 }
  ],
  cebola: [
    // FAO-56, Tabela 11: cebola seca em ciclo representativo de 150 dias.
    { fase: 'Emergência e estabelecimento', dias: 15 },
    { fase: 'Desenvolvimento foliar', dias: 25 },
    { fase: 'Bulbificação e enchimento', dias: 70 },
    { fase: 'Maturação e tombamento', dias: 40 }
  ],
  banana: [
    // FAO-56, Tabela 11: primeiro ciclo produtivo de 390 dias.
    { fase: 'Implantação e estabelecimento', dias: 120 },
    { fase: 'Desenvolvimento vegetativo', dias: 90 },
    { fase: 'Diferenciação floral e emissão do cacho', dias: 120 },
    { fase: 'Enchimento e maturação dos frutos', dias: 60 }
  ],
  citros: [
    // FAO-56, Tabela 11: ciclo produtivo anual de pomar estabelecido.
    { fase: 'Brotação e florescimento', dias: 60 },
    { fase: 'Pegamento e expansão inicial dos frutos', dias: 90 },
    { fase: 'Crescimento dos frutos', dias: 120 },
    { fase: 'Maturação e colheita', dias: 95 }
  ],
  uva: [
    // FAO-56, Tabela 11: ciclo de 240 dias para videira em baixas latitudes.
    { fase: 'Brotação', dias: 20 },
    { fase: 'Crescimento vegetativo e florescimento', dias: 40 },
    { fase: 'Pegamento e crescimento das bagas', dias: 120 },
    { fase: 'Maturação e colheita', dias: 60 }
  ],
  cacau: [
    // CEPLAC: referência para implantação por mudas; a frutificação varia com material e ambiente.
    { fase: 'Pegamento e estabelecimento', dias: 90 },
    { fase: 'Crescimento vegetativo juvenil', dias: 640 },
    { fase: 'Formação da copa e entrada em produção', dias: 365 },
    { fase: 'Florescimento e pegamento dos frutos', dias: 60 },
    { fase: 'Desenvolvimento, maturação e colheita', dias: 180 }
  ],
  braquiaria: [
    // Embrapa Gado de Corte: estabelecimento inicial; o manejo posterior deve seguir altura do dossel.
    { fase: 'Germinação e emergência', dias: 10 },
    { fase: 'Estabelecimento', dias: 20 },
    { fase: 'Perfilhamento e cobertura do solo', dias: 30 },
    { fase: 'Consolidação até o primeiro pastejo', dias: 30 }
  ],
  capim_mombaca: [
    // Embrapa Gado de Corte: estabelecimento inicial; reentrada deve considerar a altura recomendada.
    { fase: 'Germinação e emergência', dias: 10 },
    { fase: 'Estabelecimento', dias: 20 },
    { fase: 'Perfilhamento e formação do dossel', dias: 30 },
    { fase: 'Consolidação até o primeiro pastejo', dias: 30 }
  ]
};
